import { toValue, type MaybeRefOrGetter } from "vue";
import { useSurveysStore } from "@stores/surveys";
import { usePaginatedOptions } from "./usePaginatedOptions";

export const useSurveyOptions = (
  status: MaybeRefOrGetter<string | null> = null,
  accountIds: MaybeRefOrGetter<number[]> = [],
) => {
  const { fetchLightSurveyOptionsPage } = useSurveysStore();
  return usePaginatedOptions((page, search) => fetchLightSurveyOptionsPage(page, search, toValue(status), toValue(accountIds)));
};
